import { createContext } from 'react'
import { NAIL_TRIMMING_OPTIONS, EAR_CLEANING_OPTIONS, GLANDS_OPTIONS } from './constants'
export const initialGroomingSetupValues = {
	_id: '',
	name: '',
	image_url: '',
	breeds: [],
	breed_mix: '',
	coat_type: '',
	weight: null,
	shedding: '',
	shedding_amount: '',
	shedding_frequency: '',
	closest_breed_coat: '',
	coat_length: '',
	grooming_level: '',
	allowed_grooming_services: [],
	grooming_addons: [],
	nail_trimming: NAIL_TRIMMING_OPTIONS.standard,
	ear_cleaning: EAR_CLEANING_OPTIONS.standard,
	glands: GLANDS_OPTIONS.standard,
	client_grooming_notes: '',
	reference_photo_email_sent: false,
	household_id: ''
}

const GroomingProfileWizardContext = createContext()
export default GroomingProfileWizardContext
